<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader class="pb-0">
          <strong>{{getActionTitle}} </strong>
          <span style="text-decoration: underline;" >{{params.component}}  </span>
          <strong> - Mã: </strong>
          <span  style="text-decoration: underline;">{{params.part}}</span>
          <div class="form-group float-right">
            <CButton type="button" color="secondary" shape="pill" class="mr-2"
                     @click="goBack"
            >
              <CIcon name="cil-chevron-left"/>
              Quay lại
            </CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="actions"
            :fields="getHeaders"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            :itemsPerPage="100"
            columnFilter
            sorter
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>

            <template #content="{item}">
              <td>
                <div v-html="item.content"></div>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      headers_import: [
        {key: 'stt', label: 'Stt'},
        {key: 'user', label: 'Người nhập'},
        {key: 'quantity', label: 'Số lượng nhập'},
        {key: 'location', label: 'Địa điểm'},
        {key: 'time', label: 'Thời gian'},
        {key: 'note', label: 'Ghi chú'},
      ],
      headers_export:[
        {key: 'stt', label: 'Stt'},
        {key: 'user', label: 'Người xuất'},
        {key: 'quantity', label: 'Số lượng xuất'},
        {key: 'location', label: 'Địa điểm'},
        {key: 'time', label: 'Thời gian'},
        {key: 'note', label: 'Ghi chú'},
      ],
      headers_edit: [
        {key: 'stt', label: 'Stt'},
        {key: 'user', label: 'Người sửa'},
        {key: 'content', label: 'Nội dung'},
        {key: 'time', label: 'Thời gian'},
        {key: 'note', label: 'Ghi chú'},
      ],
      headers_all: [
        {key: 'stt', label: 'Stt', _style: 'width: 2rem;'},
        {key: 'action', label: 'Thao tác'},
        {key: 'user', label: 'Người thực hiện'},
        {key: 'content', label: 'Nội dung'},
        {key: 'quantity', label: 'Số lượng'},
        {key: 'location', label: 'Địa điểm'},
        {key: 'time', label: 'Thời gian'},
        {key: 'note', label: 'Ghi chú'},
        {key: 'ts', label: 'Thực hiện'},
      ],
      headers: [],
      // Example data
      actions: [],
      params: {
        action: '',
        component: '',
        part: '',
        criteria: '',
        searched: false,
      },
      userRole: '',
    };
  },
  mounted() {
    this.userRole = localStorage.getItem('role');
  },
  created() {
    this.params = this.$route.query;
    // console.log(this.params);
    this.getAll()
  },
  computed: {
    getHeaders() {
      return this.headers_all;
      // if(this.params.action === 'import') {
      //   return this.headers_import;
      // } else if(this.params.action === 'export') {
      //   return this.headers_export;
      // } else if(this.params.action === 'edit') {
      //   return this.headers_edit;
      // } else if(this.params.action === 'reserve') {
      //   return this.headers;
      // }
    },
    getActionTitle() {
      // if(this.params.action === 'import') {
      //   return 'Lịch sử nhập kho linh kiện: ';
      // } else if(this.params.action === 'export') {
      //   return 'Lịch sử xuất kho linh kiện: ';
      // } else if(this.params.action === 'edit') {
      //   return 'Lịch sử chỉnh sửa linh kiện: ';
      // } else if(this.params.action === 'reserve') {
      //   return 'Danh mục đặt trước linh kiện: ';
      // }
      return 'Lịch sử linh kiện nhóm: ';
    }
  },
  methods: {
    getAll() {
      this.$request.get(
        `/api/repo/history?action=${this.params.action}&component=${this.params.component}&part=${this.params.part}`).then(res => {
        // console.log(res.data)
        this.actions = res.data.actions;
      })
    },
    goBack() {
      // console.log('back with param:', this.params)
      if(this.params.searched) {
        this.$router.push({
          path: `/component/search`,
          query: this.params,
        })
      } else {
        this.$router.go(-1)
      }
    },
  }
};
</script>
